import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import LoadScript from 'vue-plugin-load-script';
import store from '@/store'
import middlewarePipeline from './middlewarePipeline'

import {
    Home,
    Login,
    BillServices,
    ReceiptBillServices,
    ForgetPass,
    Register,
    RegisterWithReferer,
    Verify,
    Logout,
    NamadUser,
    Profile,
    ProfileUpdate,
    ProfileUpdateLegalUser,
    ProfileAuthenticate,
    ProfileShebaNumbers,
    ProfileAddresses,
    ProfileChangPassword,
    ProfileChangeSettlementPayaWage,
    ProfileNamad,
    GatewayGet,
    StarShopGatewayGet,
    GatewayCreate,
    GatewayUpdate,
    GatewayAllotment,
    GatewayStakeholdersList,

    UserGet,
    UserDetails,
    UserActivityLog,
    ChangeUserPassword,
    UpdateContract,
    UsersCategories,
    UsersCategoryDetail,
    UsersCategoryUpdate,
    UsersGroups,
    UsersGroupUpdate,

    StakeholdersGet,
    StakeholdersCreate,
    StakeholdersCreatePfType,
    StakeholdersCreateFromUsers,
    StakeholdersCreatePspType,
    StakeholdersUpdate,
    StakeholdersUpdatePfType,
    StakeholdersUpdateWalletType,
    StakeholdersUpdatePspType,
    StakeholdersChangeStatus,
    StakeholdersShopsInfo,

    GatewayTransactionsReport,
    WalletSettings,
    ShareholderCreate,
    ShareholderUpdate,
    ShareholderPaginate,

    AyandeWalletsGet,
    AyandeWalletsAdminSettings,
    AyandeWalletsAdminManualSettlement,
    AyandeWalletsChargeByOauth,
    AyandeWalletsChargeByBill,
    AyandeWalletsSettlementDetail,
    AyandeWalletsAutoSettlement,
    AyandeWalletsAdminPaySettlement,
    AyandeWalletsCreate,
    AyandeWalletsCharge,
    AyandeWalletsTransfer,
    AyandeWalletsPassword,
    AyandeWalletsSettlement,
    AyandeWalletsTransaction,
    AyandeWalletsSettlementList,
    AyandeWalletsAdminGet,
    ChargeByReceipt,
    UpdateReceipt,

    DayWalletsGet,
    DayWalletsAdminSettings,
    DayWalletsChargeByOauth,
    DayWalletsChargeByBill,
    DayWalletsSettlementDetail,
    DayWalletsAdminPaySettlement,
    DayWalletsCreate,
    DayWalletsCharge,
    DayWalletsTransfer,
    DayWalletsSettlement,
    DayWalletsTransaction,
    DayWalletsSettlementList,
    DayWalletsAdminGet,

    GatewayDetails,
    TicketGet,
    TicketCreate,
    TicketComments,
    TransactionGet,
    TransactionInquiry,
    StoreGet,
    StoreCreate,
    StoreUpdate,
    StoreCoupon,
    StoreCoupons,
    ProductGet,
    ProductCreate,
    ProductUpdate,
    ProductDetails,
    ProductTags,
    ProductDiscounts,
    PardakhtShakhsiGet,
    PardakhtShakhsiDetails,
    PardakhtShakhsiDirect,
    PardakhtShakhsiCheckout,
    PardakhtShakhsiReceipt,
    NotificationsGet,
    NotificationGet,
    NotificationSmsGet,
    RechargeResult,

    VerifyMail,

    SettlementGet,
    SettlementDetails,
    SettlementFiles,
    SettlementVpnLog,
    SettlementQueue,
    SettlementCreateRequest,

    PaymanGet,
    PaymanCreate,
    PaymanUpdate,
    PaymanDetails,

    IVRCreate,
    IVRUpdate,
    IVRDetails,
    IVRGet,

    DedicatedUpdate,
    DedicatedDetails,
    DedicatedCreate,
    DedicatedGet,
    DedicatedStakeholders,
    DedicatedAllotment,
    DedicatedStatementsReportUser,

    MoneyRequestGet,
    MoneyRequestCreate,
    MoneyRequestPay,
    MoneyRequestReceipt,

    StorePage,
    ProductPage,
    AllCart,

    PspRequestGet,
    PspRequestDetails,

    ShaparakRequestsGet,

    CoreMarketingDashboard,
    StarshopMarketingDashboard,
    MarketingTools,
    MarketerSubsets,
    MarketerManaging,
    MarketingSetting,
    SubsetsPSPTransactionsReport,
    SubsetsAppTransactionsReport,
    SubsetsSettlementsReport,
    posAgentSetting,
    MarketingPos,
    ChangeAgent,

    BlackList,

    GatewaysReports,
    UsersReports,

    AccessDenied,
    NewsGet,
    NewsCreate,
    NewsUpdate,
    ShowNews,

    CollectiveGet,
    CollectiveDetails,
    CollectiveActiveGateways,
    CollectiveCreate,
    CollectiveGatewayDetails,
    StatementsReportUser,
    TransactionsReport,
    DedicatedTransactionsReport,
    OfflineTransaction,
    OnlineTransaction,

    KnowledgeQuestionsGet,
    KnowledgeCategoryDetails,
    KnowledgeCategoryUpdate,
    KnowledgeQuestionCreate,
    KnowledgeQuestionUpdate,
    GetwayeStatementsReport,
    GetwayeStatementsReportDedicated,

    FAQQuestionsGet,
    FAQCategoryDetails,
    FAQCategoryUpdate,
    FAQQuestionCreate,
    FAQQuestionUpdate,




    OnlineFactor,
    OnlineFactorCreateItems,
    OnlineFactorGetItems,
    OnlineFactorShow,
    OnlineFactorCustomers,
    OnlineFactorCreateCustomer,
    OnlineFactorShowCustomer,
    OnlineFactorGetFactor,
    OnlineFactorCreateFactor,
    OnlineFactorShowFactor,
    TransactionRoutingGet,
    OnlineFactorPayment,
    PosGet,
    PosNewRequest,
    PosRequestDetails,
    BindSerial,
    PosReplacement,
    PosRollback,
    MultiAccountEdit,
    PosRequestEdit,
    PosRequestMultiAccountEdit,
    UsersClubEvents,

    ManageBill,
    AddCorporate,
    CorporateDetails,

    ApplicationDetails,
    ApplicationsGet,
    CreateApplication,
    OpenBankingSettings,
    GetTransferRequests,
    GetRequests,
    AccessToken,

    GetTransactionFraudEvents, UserLimited, NotificationTelegram,
    GetDepositGateways,DepositDetails,DepositAccounts,DepositRequests,CreateDepositGateway,DepositRequestDetails,AddCompany,CompanyDetails,
    GetCardToCardGateways,CardToCardDetails,
    OnlineContractAdminSettings,OnlineContractAddTemplate,OnlineContractEditTemplate,

    WalletSettlementAccountBlacklist,
    ForbiddenKeywordsSettlement

} from '@/views'
import checkRule from '@/router/middleware/checkRule'
import CustomersClubSetting from "@/views/customersClub/CustomersClubSetting";
import AuthenticationSettings from "@/views/user/AuthenticationSettings";
import TopUsersChart from "../views/reports/components/top-users-chart";
import {TopUser} from "../views";
import CategoriesDedicated from "@/views/collective/Categories-dedicated.vue";
import CategoryUpdateDedicated from "@/views/collective/CategoryUpdateDedicated.vue";
import CategoryDetailsDedicated from "@/views/collective/CategoryDetailsDedicated.vue";
import PfTerminalStatistics from "@/views/reports/Pf-Terminal-Statistics-page.vue";
import Contracts from "@/views/onlineContract/Contracts.vue";
import editContract from "@/views/onlineContract/components/contract/edit-contract.vue";
import AccountingGetAccounts from '@/views/accounting/Get.vue';
import StarShopGetAccounts from '@/views/accounting/StarshopGet.vue'
import AccountDiscrepancy from '@/views/accounting/AccountDiscrepancy.vue';
import StarshopAccountDiscrepancy from '@/views/accounting/StarshopAccountDiscrepancy.vue';
import AccountingDetail from '../views/accounting/AccountingDetail.vue';
import StarshopAccountingDetail from '../views/accounting/StarshopAccountingDetail.vue';
import PfUserActivityLog from '../views/user/PfUserActivityLog.vue';
import StarShopActivityLog from '../views/user/StarShopActivityLog.vue';
import FormatDetail from "@/views/online-factor/FormatDetail.vue";
import Create_format from "@/views/online-factor/Create_format.vue";
import VerifyRegister from '../views/VerifyRegister.vue';
import GetShareholders from "../views/stakeholders/GetShareholders.vue";
import AdvertisingBanners from '../views/advertising/banners.vue';
import AdvertisingBannerCreate from '../views/advertising/create-banner.vue';
import AdvertisingBannerEdit from '../views/advertising/edit-banner.vue';

import OpenBankingDeposits from "@/views/openBanking/components/manage-access/open-banking-deposits.vue";
Vue.use(Router);
Vue.use(Meta);
Vue.use(LoadScript);

const defaultBodyClass = "kt-quick-panel--right kt-demo-panel--right kt-offcanvas-panel--right kt-header--fixed kt-header-mobile--fixed kt-subheader--fixed kt-subheader--enabled kt-subheader--solid kt-aside--enabled kt-aside--fixed"

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: Home,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/login',
            component: Login,
        },
        {
            path: '/bill-services',
            component: BillServices,
        },
        {
            path: '/bill-services/receipt/:order_id',
            component: ReceiptBillServices,
        },
        {
            path: '/forget-pass',
            component: ForgetPass,
        },
        {
            path: '/logout',
            component: Logout,
        },
        // {
        //     path: '/register',
        //     component: Register,
        // },
        // {
        //     path: '/register/:referer_id',
        //     component: RegisterWithReferer
        // },
        {
            path: '/namad/:gateway_id',
            component: NamadUser
        },
        {
            path: '/marketing/gateways/pardakhtyari',
            name: 'dashboard',
            component: CoreMarketingDashboard,
            meta: {
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/marketing/gateways/starshop',
            name: 'dashboard',
            component: StarshopMarketingDashboard,
            meta: {
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/marketing/pos-acceptors',
            name: 'marketing_pos',
            component: MarketingPos,
            meta: {
                bodyClass: defaultBodyClass,
                requiresAuth: true,
            },
        },
        {
            path: '/change-agent/:visitor_id/:agent_id/details',
            name: 'pos_chnage_agent',
            component: ChangeAgent,
            meta: {
                bodyClass: defaultBodyClass,
                requiresAuth: true,
            },
        },
        {
            path: '/marketing/tools',
            name: 'marketing_tools',
            component: MarketingTools,
            meta: {
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/marketing/:user_id/subsets',
            name: 'marketing_subsets',
            component: MarketerSubsets,
            meta: {
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/marketing/:user_id/actions/:tab',
            name: 'marketer_managing',
            component: MarketerManaging,
            meta: {
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/marketing/:user_id/subset-psp-transactions-report',
            name: 'subset_transactions_report',
            component: SubsetsPSPTransactionsReport,
            meta: {
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/marketing/:user_id/subset-app-transactions-report',
            name: 'subset_transactions_report',
            component: SubsetsAppTransactionsReport,
            meta: {
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/marketing/setting',
            name: 'marketing_setting',
            component: MarketingSetting,
            meta: {
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/marketing/subsets-settlements',
            name: 'subsets_settlements_report',
            component: SubsetsSettlementsReport,
            requiresAuth: true,
            bodyClass: defaultBodyClass,
        },
        {
            path: '/pos-setting/:id/details',
            name: 'pos_agent_setting',
            component: posAgentSetting,
            meta: {
                bodyClass: defaultBodyClass,
                requiresAuth: true,
            },
        },
        {
            path: '/change-agent/:visitor_id/:agent_id/details',
            name: 'pos_chnage_agent',
            component: ChangeAgent,
            meta: {
                bodyClass: defaultBodyClass,
                requiresAuth: true,
            },
        },
        {
            path: '/transaction-routing/pardakhtyari',
            name: 'transaction_routing_pardakhtyari',
            component: TransactionRoutingGet,
            meta: {
                rules: {
                    transaction: ['manage']
                },
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/transaction-routing/starshop',
            name: 'transaction_routing_starshop',
            component: TransactionRoutingGet,
            meta: {
                rules: {
                    transaction: ['manage']
                },
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/verify',
            component: Verify,
        },
                {
            path: '/verifyRegister',
            component: VerifyRegister,
        },

        {
            path: '/profile',
            component: Profile,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/profile/update',
            component: ProfileUpdate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/profile/update-legal-user',
            component: ProfileUpdateLegalUser,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/profile/authenticate',
            component: ProfileAuthenticate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/profile/sheba-numbers',
            component: ProfileShebaNumbers,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/profile/addresses',
            component: ProfileAddresses,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/profile/change-password',
            component: ProfileChangPassword,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/profile/namad/:gateway_id',
            component: ProfileNamad,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/authentication-settings',
            component: AuthenticationSettings,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/pf-gateways',
            name: 'pf-gateways',
            component: GatewayGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/starshop-gateways',
            name: 'starshop-gateways',
            component: StarShopGatewayGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/gateways/create',
            name: 'gateways_create',
            component: GatewayCreate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/gateways/update/:hashid',
            name: 'gateways_update',
            component: GatewayUpdate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/gateway/:gateway_source/:hashid/details',
            name: 'gateways_details',
            component: GatewayDetails,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                middleware: [

                ],
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/gateways/:hashid/allotment',
            name: 'gateways_allotment',
            component: GatewayAllotment,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/gateways/transactions-report/:hashid',
            name: 'gateway_transactions_report',
            component: GatewayTransactionsReport,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/psp-request',
            name: 'psp_request_get',
            component: PspRequestGet,
            meta: {
                requiresAuth: true,
                rules: {
                    gateway: ['manage']
                },
                middleware: [
                ],
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/psp-request/:hashid/details',
            name: 'psp_request_details',
            component: PspRequestDetails,
            meta: {
                requiresAuth: true,
                rules: {
                    gateway: ['manage']
                },
                middleware: [
                ],
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/shaparak-requests',
            name: 'shaparak_requests_get',
            component: ShaparakRequestsGet,
            meta: {
                requiresAuth: true,
                rules: {
                    gateway: ['manage']
                },
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: "/news",
            name: "news",
            component: NewsGet,
            meta: {
                requiresAuth: true,
                rules: {
                    user: ["manage"],
                },
                middleware: [],
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: "/news/create",
            name: "news_create",
            component: NewsCreate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: "/news/update/:hashid",
            name: "News_Update",
            component: NewsUpdate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: "/news/see/:newsid",
            name: "NewsSee",
            component: UserGet,
            meta: {
                requiresAuth: true,
                rules: {
                    user: ["manage"],
                },
                middleware: [],
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: "/news/:newsid",
            name: "See",
            component: ShowNews,
            meta: {
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/users',
            name: 'users',
            component: UserGet,
            meta: {
                requiresAuth: true,
                rules: {
                    user: ['manage']
                },
                middleware: [

                ],
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/users/:tab',
            name: 'users',
            component: UserGet,
            meta: {
                requiresAuth: true,
                rules: {
                    user: ['manage']
                },
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/users/:hashid/details',
            name: 'users_details',
            component: UserDetails,
            meta: {
                requiresAuth: true,
                rules: {
                    user: ['manage']
                },
                middleware: [
                ],
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/users/:hashid/pf-activities-logs',
            name: 'user_activity_log',
            component: PfUserActivityLog,
            meta: {
                requiresAuth: true,
                rules: {
                    user: ['manage']
                },
                middleware: [
                ],
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/users/:hashid/starshop-activities-logs',
            name: 'uuser_activity_log',
            component: StarShopActivityLog,
            meta: {
                requiresAuth: true,
                rules: {
                    user: ['manage']
                },
                middleware: [
                ],
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/users/:hashid/change-password',
            name: 'change_user_password',
            component: ChangeUserPassword,
            meta: {
                requiresAuth: true,
                rules: {
                    user: ['manage']
                },
                middleware: [
                ],
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/users-categories',
            name: 'user_categories',
            component: UsersCategories,
            meta: {
                requiresAuth: true,
                rules: {
                    user: ['manage']
                },
                middleware: [
                ],
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/user-categories/:hashid/details',
            name: 'user_category_details',
            component: UsersCategoryDetail,
            meta: {
                requiresAuth: true,
                rules: {
                    user: ['manage']
                },
                middleware: [
                ],
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/update-category/:hashid',
            name: 'update_user_category',
            component: UsersCategoryUpdate,
            meta: {
                requiresAuth: true,
                rules: {
                    user: ['manage']
                },
                middleware: [
                ],
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/update-group/:hashid/:cat_id',
            name: 'update_user_group',
            component: UsersGroupUpdate,
            meta: {
                requiresAuth: true,
                rules: {
                    user: ['manage']
                },
                middleware: [
                ],
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/user-groups/:cat_id',
            name: 'user_groups',
            component: UsersGroups,
            meta: {
                requiresAuth: true,
                rules: {
                    user: ['manage']
                },
                middleware: [
                ],
                bodyClass: defaultBodyClass,
            },
        },

        {
            path: '/shareholder/create',
            name: 'shareholder-create',
            component: ShareholderCreate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/shareholder/update/:hashid',
            name: 'shareholder-update',
            component: ShareholderUpdate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/shareholders',
            name: 'shareholder-paginate',
            component: ShareholderPaginate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },

        // {
        //     path: '/wallets',
        //     name: 'ayande_wallets_get',
        //     component: AyandeWalletsGet,
        //     meta: {
        //         requiresAuth: true,
        //         bodyClass: defaultBodyClass,
        //     },
        // },
        {
            path: '/wallets/create',
            name: 'ayande_wallets_create',
            component: AyandeWalletsCreate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        // {
        //     path: '/wallets/charge/:hashid',
        //     name: 'ayande_wallets_charge',
        //     component: AyandeWalletsCharge,
        //     meta: {
        //         requiresAuth: true,
        //         bodyClass: defaultBodyClass,
        //     },
        // },
        {
            path: '/wallets/charge-by-oauth/:hashid',
            name: 'ayande_wallets_charge_by_oauth',
            component: AyandeWalletsChargeByOauth,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/wallets/password/:hashid',
            name: 'ayande_wallets_password',
            component: AyandeWalletsPassword,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/wallets/transfer/:hashid',
            name: 'ayande_wallets_transfer',
            component: AyandeWalletsTransfer,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/wallets/settlement/:hashid',
            name: 'ayande_wallets_settlement',
            component: AyandeWalletsSettlement,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/wallets/settlement-detail/:hashid',
            name: 'ayande_wallets_settlement_detail',
            component: AyandeWalletsSettlementDetail,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/wallets/auto-settlement/:hashid',
            name: 'ayande_wallets_auto_settlement',
            component: AyandeWalletsAutoSettlement,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/wallets/transaction/:hashid',
            name: 'ayande_wallets_transaction',
            component: AyandeWalletsTransaction,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/wallets/settlement-list/:hashid',
            name: 'ayande_wallets_settlement_list',
            component: AyandeWalletsSettlementList,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/wallets/admin/:slug',
            name: 'ayande_wallets_admin_get',
            component: AyandeWalletsAdminGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/wallets/admin/:slug/:hashid',
            name: 'ayande_wallets_admin_wallet_settings',
            component: AyandeWalletsAdminSettings,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/wallets/charge-by-receipt/:slug/:hashid',
            name: 'ayande_wallets_charge-by-receipt',
            component: ChargeByReceipt,
            props: true,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/wallets/update-receipt/:slug/:hashid',
            name: 'ayande_wallets_update_receipt',
            component: UpdateReceipt,
            props: true,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/wallets/admin/manual-settlement/:hashid',
            name: 'ayande_wallets_admin_manual_settlement',
            component: AyandeWalletsAdminManualSettlement,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/wallets/admin/pay-settlement/:slug/:hashid',
            name: 'ayande_wallets_admin_pay_settlement',
            component: AyandeWalletsAdminPaySettlement,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },

        {
            path: '/day-wallets',
            name: 'day_wallets_get',
            component: DayWalletsGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/day-wallets/create',
            name: 'day_wallets_create',
            component: DayWalletsCreate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/day-wallets/charge/:hashid',
            name: 'day_wallets_charge',
            component: DayWalletsCharge,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/day-wallets/charge-by-oauth/:hashid',
            name: 'day_wallets_charge_by_oauth',
            component: DayWalletsChargeByOauth,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/day-wallets/charge-by-bill/:hashid',
            name: 'day_wallets_charge_by_bill',
            component: DayWalletsChargeByBill,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/day-wallets/transfer/:hashid',
            name: 'day_wallets_transfer',
            component: DayWalletsTransfer,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/day-wallets/settlement/:hashid',
            name: 'day_wallets_settlement',
            component: DayWalletsSettlement,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/day-wallets/settlement-detail/:hashid',
            name: 'day_wallets_settlement_detail',
            component: DayWalletsSettlementDetail,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/day-wallets/transaction/:hashid',
            name: 'day_wallets_transaction',
            component: DayWalletsTransaction,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/day-wallets/settlement-list/:hashid',
            name: 'day_wallets_settlement_list',
            component: DayWalletsSettlementList,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/day-wallets/admin',
            name: 'day_wallets_admin_get',
            component: DayWalletsAdminGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/day-wallets/admin/:hashid',
            name: 'day_wallets_admin_wallet_settings',
            component: DayWalletsAdminSettings,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/day-wallets/admin/pay-settlement/:hashid',
            name: 'day_wallets_admin_pay_settlement',
            component: DayWalletsAdminPaySettlement,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },

        {
            path: '/stakeholders/pf',
            name: 'stakeholders_pf_get',
            component: StakeholdersGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/stakeholders/starshop',
            name: 'stakeholders_starshop_get',
            component: GetShareholders,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/stakeholders/create',
            name: 'stakeholders_create',
            component: StakeholdersCreate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/stakeholders/create-pf-type',
            name: 'stakeholders_create_business_type',
            component: StakeholdersCreatePfType,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/stakeholders/create-from-users',
            name: 'stakeholders_create_from_users',
            component: StakeholdersCreateFromUsers,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/stakeholders/create-psp-type',
            name: 'stakeholders_create_psp_type',
            component: StakeholdersCreatePspType,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/stakeholders/update/:hashid',
            name: 'stakeholders_update',
            component: StakeholdersUpdate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/stakeholders/update-pf-type/:hashid',
            name: 'stakeholders_update_business_type',
            component: StakeholdersUpdatePfType,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/stakeholders/update-wallet-type/:hashid',
            name: 'stakeholders_update_wallet_type',
            component: StakeholdersUpdateWalletType,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/stakeholders/update-psp-type/:hashid',
            name: 'stakeholders_update_psp_type',
            component: StakeholdersUpdatePspType,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/stakeholders/change-status/:hashid',
            name: 'stakeholders_change_status',
            component: StakeholdersChangeStatus,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/stakeholders/shops-info/:hashid',
            name: 'stakeholders_shops_info',
            component: StakeholdersShopsInfo,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/gateways/stakeholders/:hashid',
            name: 'gateway_stakeholders_list',
            component: GatewayStakeholdersList,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        
        {
            path: '/tickets/:tab?',
            name: 'tickets',
            component: TicketGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/ticket/create',
            name: 'tickets_create',
            component: TicketCreate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/tickets/:hashid/comments',
            name: 'tickets_comments',
            component: TicketComments,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/pf/accounting/:tab?',
            name: 'accounting',
            component: AccountingGetAccounts,
            meta: {
                requiredAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/starshop/accounting/:tab?',
            name: 'accounting',
            component: StarShopGetAccounts,
            meta: {
                requiredAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/pf/accounting/:hashid/details',
            name: 'accounting-details',
            component: AccountingDetail,
            meta: {
                requiredAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/starshop/accounting/:hashid/details',
            name: 'accounting-details',
            component: StarshopAccountingDetail,
            meta: {
                requiredAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/pf/accounting/account/discrepancies',
            name: 'accounting-discrepancy',
            component: AccountDiscrepancy,
            meta: {
                requiredAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/starshop/accounting/account/discrepancies',
            name: 'accounting-discrepancy',
            component: StarshopAccountDiscrepancy,
            meta: {
                requiredAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/transactions/pardakhtyari/:tab?',
            name: 'pardakhtyari-transactions',
            component: TransactionGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/transactions/monitoring',
            name: 'pardakhtyari-transactions-monitoring',
            component: TransactionGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/transactions/starshop/:tab?',
            name: 'pardakhtyari-transactions',
            component: TransactionGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/transactions/notifications-setting',
            name: 'notifications-setting',
            component: TransactionGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/transactions/inquiry',
            name: 'transaction-inquiry',
            component: TransactionInquiry,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/accounting/account/discrepancies',
            name: 'discrepancy',
            component: AccountDiscrepancy,
            meta: {
                requiredAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/online-factor',
            name: 'online-factor-get',
            component: OnlineFactor,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/online-factor-item-create',
            name: 'online-factor-create',
            component: OnlineFactorCreateItems,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/online-factor-factor-create',
            name: 'online-factor-factor-create',
            component: OnlineFactorCreateFactor,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/online-factor-customer-create',
            name: 'online-factor-create',
            component: OnlineFactorCreateCustomer,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/items/:hashid/details',
            name: 'online-factor-show-item',
            component: OnlineFactorShow,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/customers/:hashid/details',
            name: 'online-factor-show-customer',
            component: OnlineFactorShowCustomer,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/customer-formats/:hashid/details',
            name: 'online-factor-show-customer',
            component: FormatDetail,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/online-factor-format-create',
            name: 'online-factor-format-create',
            component: Create_format,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/factor/:hashid/details',
            name: 'online-factor-show-factor',
            component: OnlineFactorShowFactor,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/invoice/:hashid',
            name: 'online-factor-pay-factor',
            component: OnlineFactorPayment,
            meta: {
                requiresAuth: false,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/money-request',
            name: 'money-request',
            component: MoneyRequestGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/money-request-create',
            name: 'money-request-create',
            component: MoneyRequestCreate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/pay/:tracking_code',
            name: 'money-request-pay',
            component: MoneyRequestPay,
            meta: {
                requiresAuth: false,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/money-request-receipt/:tracking_code',
            name: 'money-request-receipt',
            component: MoneyRequestReceipt,
            meta: {
                requiresAuth: false,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/stores',
            name: 'stores',
            component: StoreGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/stores/create',
            name: 'stores_create',
            component: StoreCreate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/stores/update/:hashid',
            name: 'stores_update',
            component: StoreUpdate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/stores/:store_hashid/coupons/create',
            name: 'store_coupon',
            component: StoreCoupon,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/stores/:store_hashid/coupons',
            name: 'stores_coupon',
            component: StoreCoupons,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/stores/:store_hashid/products',
            name: 'products',
            component: ProductGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/stores/:store_hashid/products/create',
            name: 'products_create',
            component: ProductCreate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/stores/:store_hashid/products/update/:hashid',
            name: 'products_update',
            component: ProductUpdate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/stores/:store_hashid/products/details/:hashid',
            name: 'products_details',
            component: ProductDetails,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/stores/:store_hashid/products/tag/:hashid',
            name: 'products_tags',
            component: ProductTags,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/stores/:store_hashid/products/discount/:hashid',
            name: 'products_discount',
            component: ProductDiscounts,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },

        /**
         * Settlement
         */
        {
            path: '/settlements',
            name: 'settlements',
            component: SettlementGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/settlements/:hashid/details',
            name: 'settlements_details',
            component: SettlementDetails,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
                rules: {
                    transaction: ['manage']
                },
                middleware: [
                ],
            },
        },
        {
            path: '/settlements/vpn-log',
            name: 'settlements_vpn_log',
            component: SettlementVpnLog,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
                rules: {
                    transaction: ['manage']
                },
                middleware: [
                ],
            },
        },
        {
            path: '/settlements/files',
            name: 'settlements_files',
            component: SettlementFiles,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
                rules: {
                    transaction: ['manage']
                },
                middleware: [
                ],
            },
        },
        {
            path: '/settlements/queue',
            name: 'settlements_queue',
            component: SettlementQueue,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/settlements/create-request',
            name: 'settlements_create_request',
            component: SettlementCreateRequest,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },

        /**
         * Payman
         */
        {
            path: '/payman',
            name: 'payman',
            component: PaymanGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/payman/create',
            name: 'payman_create',
            component: PaymanCreate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/payman/update/:hashid',
            name: 'payman_update',
            component: PaymanUpdate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/payman/:hashid/details',
            name: 'payman_details',
            component: PaymanDetails,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                middleware: [

                ],
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },

        /**
         * IVR
         */
        {
            path: '/ivr/create',
            name: 'ivr_create',
            component: IVRCreate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/ivr/update/:hashid',
            name: 'ivr_update',
            component: IVRUpdate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/ivr/:hashid/details',
            name: 'ivr_details',
            component: IVRDetails,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                middleware: [

                ],
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/ivr',
            name: 'ivr',
            component: IVRGet,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                middleware: [

                ],
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },

        /**
         * Dedicated
         */
        {
            path: '/dedicated/create',
            name: 'dedicated_create',
            component: DedicatedCreate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/dedicated/update/:hashid',
            name: 'dedicated_update',
            component: DedicatedUpdate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/dedicated/:hashid/details',
            name: 'dedicated_details',
            component: DedicatedDetails,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                middleware: [

                ],
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/dedicated',
            name: 'dedicated',
            component: DedicatedGet,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                middleware: [

                ],
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },

        {
            path: '/dedicated/stakeholders/:hashid',
            name: 'dedicated_stakeholders_list',
            component: DedicatedStakeholders,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/dedicated/:hashid/allotment',
            name: 'dedicated_allotment',
            component: DedicatedAllotment,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },

        /**
         * Pardakht Shakhsi
         */
        {
            path: '/pardakht-shakhsi/settings',
            name: 'pardakht_shakhsi',
            component: PardakhtShakhsiGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/pardakht-shakhsi/:hashid/details',
            name: 'pardakht_shakhsi_details',
            component: PardakhtShakhsiDetails,
            meta: {
                rules: {
                    pardakht_shakhsi: ['manage']
                },
                middleware: [

                ],
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },

        // Collective Gateways
        {
            path: '/collective',
            name: 'collective_get',
            component: CollectiveGet,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/collective/create',
            name: 'collective_create',
            component: CollectiveCreate,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/collective/:hashid/details',
            name: 'collective_details',
            component: CollectiveDetails,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/collective/gateway/:hashid/details',
            name: 'collective_gateway_details',
            component: CollectiveGatewayDetails,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/collective/gateway/:hashid/online-transaction',
            name: 'collective_gateway_online_transaction',
            component: OnlineTransaction,
            props: true,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/collective/gateway/:hashid/offline-transaction',
            name: 'collective_gateway_offline_transaction',
            component: OfflineTransaction,
            props: true,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/collective/active-gateways',
            name: 'active_gateways',
            component: CollectiveActiveGateways,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/collective/dedicated-categories',
            name: 'dedicated_categories',
            component: CategoriesDedicated,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/collective/update-category-dedicated/:hashid',
            name: 'dedicated_categories_update',
            component: CategoryUpdateDedicated,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },

        {
            path: '/collective/dedicated-categories/:hashid/details',
            name: 'dedicated_categories_details',
            component: CategoryDetailsDedicated,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },

// Pos
        {
            path: '/pos',
            name: 'pos_get',
            component: PosGet,
            meta: {
                // rules: {
                // },
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/pos/add-new-request',
            name: 'pos_new_request',
            component: PosNewRequest,
            meta: {
                // rules: {
                // },
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/pos/multi_account/:index/edit',
            name: 'pos_multi_account_edit',
            component: MultiAccountEdit,
            meta: {
                // rules: {
                //
                // },
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/pos/:hashid/details',
            name: 'pos_details',
            component: PosRequestDetails,
            meta: {
                // rules: {
                //
                // },
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/pos/edit/:hashid',
            name: 'pos_edit',
            component: PosRequestEdit,
            meta: {
                // rules: {
                //
                // },
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/pos/edit/multi-account/:hashid',
            name: 'pos_edit_multi_account',
            component: PosRequestMultiAccountEdit,
            meta: {
                // rules: {
                //
                // },
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/pos/request-details/:hashid',
            name: 'pos_request_detail',
            component: PosRequestDetails,
            meta: {
                // rules: {
                //
                // },
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/pos/bind_serial/:terminal_id',
            name: 'bind_serial',
            component: BindSerial,
            meta: {
                // rules: {
                //
                // },
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/pos/pos_replacement/:followup_code/:terminal_id',
            name: 'pos_replacement',
            component: PosReplacement,
            meta: {
                // rules: {
                //
                // },
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/pos/rollback/:followup_code/:terminal_id',
            name: 'pos_rollback',
            component: PosRollback,
            meta: {
                // rules: {
                //
                // },
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        // Notification
        {
            path: '/notification-email',
            name: 'notification_settings',
            component: NotificationGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        ///Notification Sms
        {
            path: '/notification-sms',
            name: 'notification_sms_settings',
            component: NotificationSmsGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        ///Notification Sms
        {
            path: '/notification-telegram',
            name: 'notification_telegram_settings',
            component: NotificationTelegram,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/notification-sms/recharge-result/:tracking_code',
            name: 'recharge-result',
            component: RechargeResult,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/access-token',
            name: 'access_token',
            component: AccessToken,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/security/black-list',
            name: 'security-black-list',
            component: BlackList,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/reports/gateways',
            name: 'gateways-reports',
            component: GatewaysReports,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },

        {
            path: '/reports/users',
            name: 'reports-users',
            component: UsersReports,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/reports/top-users-chart',
            name: 'top-users-chart',
            component: TopUser,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/reports/pf-terminal-statistics',
            name: 'pf-terminal-statistics',
            component: PfTerminalStatistics,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },
        // Public access pages
        // {
        //     path: '/@:store',
        //     name: 'store_page',
        //     component: StorePage,
        //     meta: {
        //         requiresAuth: false,
        //         bodyClass: "",
        //     },
        // },
        // {
        //     path: '/@:store/:product_hashid',
        //     name: 'product_page',
        //     component: ProductPage,
        //     meta: {
        //         requiresAuth: false,
        //         bodyClass: "",
        //     },
        // },
        // {
        //     path: '/cart/@:store',
        //     name: 'cart_page',
        //     component: AllCart,
        //     meta: {
        //         requiresAuth: false,
        //         bodyClass: "",
        //     },
        // },

        {
            path: '/@:username',
            name: 'direct_pay',
            component: PardakhtShakhsiDirect,
            meta: {
                requiresAuth: false,
                bodyClass: "body",
            },
        },
        {
            path: '/@:username/:price',
            name: 'direct_pay',
            component: PardakhtShakhsiDirect,
            meta: {
                requiresAuth: false,
                bodyClass: "body",
            },
        },
        {
            path: '/pay/:tracking_code',
            name: 'direct_checkout',
            component: PardakhtShakhsiCheckout,
            meta: {
                requiresAuth: false,
                bodyClass: "body",
            },
        },
        {
            path: '/receipt/:tracking_code',
            name: 'direct_receipt',
            component: PardakhtShakhsiReceipt,
            meta: {
                requiresAuth: false,
                bodyClass: "body",
            },
        },

        // Email Verification
        {
            path: '/verify-mail/:tracking_code',
            name: 'verify_mail',
            component: VerifyMail,
            meta: {
                requiresAuth: false,
                bodyClass: "body",
            },
        },


        
        {
            path: '/access-denied',
            name: 'access_denied',
            component: AccessDenied,
            meta: {
                bodyClass: defaultBodyClass,
            },
        },
        {
            path:'/knowledge-management',
            name:'knowledge_management',
            component: KnowledgeQuestionsGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path:'/knowledge-categories/:hashid/details',
            name:'ticket_category_details',
            component: KnowledgeCategoryDetails,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path:'/update-knowledge-categories/:hashid',
            name:'ticket_category_update',
            component: KnowledgeCategoryUpdate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path:'/knowledge-questions/:hashid/create',
            name:'category_question_create',
            component: KnowledgeQuestionCreate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path:'/knowledge-questions/:hashid/update',
            name:'category_question_update',
            component: KnowledgeQuestionUpdate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/gateways/statements-report/:hashid',
            name: 'gateway_statements_report',
            component: GetwayeStatementsReport,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/dedicated/statements-report/:hashid',
            name: 'gateway_statements_report_dedicated',
            component: GetwayeStatementsReportDedicated,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {

            path: '/dedicated/transactions-report/:hashid',
            name: 'dedicated_transactions_report',
            component: DedicatedTransactionsReport,
            meta: {
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/gateways/transactions-report/:hashid',
            name: 'transactions-report',
            component: TransactionsReport,
            meta: {
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/gateways/statements-report/:hashid',
            name: 'statements-user',
            component: StatementsReportUser,
            meta: {
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/dedicated/statements-report/:hashid',
            name: 'dedicated_statements_report',
            component: DedicatedStatementsReportUser,
            meta: {
                bodyClass: defaultBodyClass,
            },
        },
        {
            path: '/customers-club-settings',
            name: 'customers_club',
            component: CustomersClubSetting,
            meta: {
                rules: {
                    transaction: ['manage']
                },
                middleware: [

                ],
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },

        {
            path: '/fraud-events/:tab?',
            name: 'fraudEvents',
            component: GetTransactionFraudEvents,
            meta: {
                rules: {
                    transaction: ['manage']
                },
                bodyClass: defaultBodyClass,
                requiresAuth: true,
            }
        },

        {
            path: '/user-has-limited/:tab?',
            name: 'userHasLimited',
            component: UserLimited,
            meta: {
                rules: {
                    user: ['manage']
                },
                bodyClass: defaultBodyClass,
                requiresAuth: true,
            }
        },
        {
            path:'/knowledge-management',
            name:'knowledge_management',
            component: KnowledgeQuestionsGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path:'/knowledge-categories/:hashid/details',
            name:'ticket_category_details',
            component: KnowledgeCategoryDetails,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path:'/update-knowledge-categories/:hashid',
            name:'ticket_category_update',
            component: KnowledgeCategoryUpdate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path:'/knowledge-questions/:hashid/create',
            name:'category_question_create',
            component: KnowledgeQuestionCreate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path:'/knowledge-questions/:hashid/update',
            name:'category_question_update',
            component: KnowledgeQuestionUpdate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path:'/faq',
            name:'faq',
            component: FAQQuestionsGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path:'/faq-categories/:hashid/details',
            name:'faq_category_details',
            component: FAQCategoryDetails,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path:'/faq-questions/:hashid/create',
            name:'faq_question_create',
            component: FAQQuestionCreate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path:'/faq-questions/:hashid/update',
            name:'faq_question_update',
            component: FAQQuestionUpdate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },


        //Users Club Events
        {
            path: '/users-club-events',
            name: 'users_club_events',
            component: UsersClubEvents,
            meta: {
                requiresAuth: true,
                rules: {
                    user: ['manage']
                },
                bodyClass: defaultBodyClass,
            }
        },
        //BILL

        {
            path: '/bill',
            name: 'bill',
            component: ManageBill,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                middleware: [

                ],
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/bill/add-corporate',
            name: 'add_corporate',
            component: AddCorporate,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                middleware: [

                ],
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/bill/corporate/:hashid/details',
            name: 'corporate_details',
            component: CorporateDetails,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                middleware: [

                ],
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },

        //OPEN_BANKING
        {
            path: '/applications',
            name: 'applications',
            component: ApplicationsGet,
            meta: {
                rules: {
                },
                middleware: [

                ],
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/applications/:hashid/details',
            name: 'application_details',
            component: ApplicationDetails,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/application/create',
            name: 'create_application',
            component: CreateApplication,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/open-banking/settings',
            name: 'open_banking_settings',
            component: OpenBankingSettings,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },

        {
            path: '/open-banking/requests/:tab?',
            name: 'open_banking_requests',
            component: GetRequests,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/open-banking/deposit/:gateway_source',
            name: 'get_deposit_gateways',
            component: GetDepositGateways,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/open-banking/deposit/:gateway_source/update/:hashid',
            name: 'deposit_details',
            component: DepositDetails,
            meta: {
                middleware: [

                ],
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/open-banking/deposit/:gateway_source/accounts',
            name: 'deposit_accounts',
            component: DepositAccounts,
            meta: {
                rules: {
                    deposit: ['manage']
                },
                middleware: [

                ],
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/open-banking/deposit/:gateway_source/requests',
            name: 'deposit_requests',
            component: DepositRequests,
            meta: {
                rules: {
                    deposit: ['manage']
                },
                middleware: [

                ],
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/open-banking/deposit/:gateway_source/requests/:hashid/details',
            name: 'deposit_request_details',
            component: DepositRequestDetails,
            meta: {
                rules: {
                    deposit: ['manage']
                },
                middleware: [

                ],
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/open-banking/deposit/:gateway_source/create',
            name: 'create_deposit_gateway',
            component: CreateDepositGateway,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/open-banking/deposit/:gateway_source/verified-companies/add',
            name: 'add_verified_company',
            component: AddCompany,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/open-banking/deposit/:gateway_source/verified-companies/:hashid/details',
            name: 'verified_company_details',
            component: CompanyDetails,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },

        {
            path: '/open-banking/transfers',
            name: 'open_banking_transfers',
            component: GetTransferRequests,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },

        {
            path: '/open-banking/deposits',
            name: 'open_banking_deposits',
            component: OpenBankingDeposits,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },

        {
            path: '/notifications',
            name: 'notifications',
            component: NotificationsGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            },
        },

        //card-to-card
        {
            path: '/card-to-card',
            name: 'get_card_to_card_gateways',
            component: GetCardToCardGateways,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/card-to-card/update/:hashid',
            name: 'card_to_card_details',
            component: CardToCardDetails,
            meta: {
                middleware: [

                ],
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        //onlineContract
        {
            path: '/online-contract',
            name: 'online_contract',
            component: OnlineContractAdminSettings,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/advertising-banners',
            name: 'advertising_banners',
            component: AdvertisingBanners,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/advertising-banners/create',
            name: 'advertising_banners_create',
            component: AdvertisingBannerCreate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/advertising-banners/edit/:hashid',
            name: 'advertising_banners_edit',
            component: AdvertisingBannerEdit,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/online-contract/add-template',
            name: 'online_contract_add_template',
            component: OnlineContractAddTemplate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/online-contract/contracts',
            name: 'online_contract',
            component: Contracts,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        {
            path: '/online-contract/:hashid',
            name: 'online_contract_show',
            component: UpdateContract,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        //onlineContract
        {
            path: '/online-contract/edit-template/:hashid',
            name: 'online_contract_edit_template',
            component: OnlineContractEditTemplate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
        // {
        //     path: '/online-contract/edit-contract/:hashid',
        //     name: 'online_contract_edit_contract',
        //     component: editContract,
        //     meta: {
        //         requiresAuth: true,
        //         bodyClass: defaultBodyClass,
        //     }
        // },
        /* Catch Alls */
        { path: '', redirect: '/login' },

        {
          path: '/:slug?/wallet-settlement-account-blacklist',
          name: 'wallet_settlement_account_blacklist',
          component: WalletSettlementAccountBlacklist,
          meta: {
            requiresAuth: true,
            bodyClass: defaultBodyClass,
          }
        },

        {
            path: '/forbidden-keywords-settlement',
            name: 'forbidden_keywords_settlement',
            component: ForbiddenKeywordsSettlement,

            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
            }
        },
    ]
})

router.beforeEach(async (to, from, next) => {
    // check if current user is null, fecth it
    if (!store.getters['user/is_current_user_fetched'] && !['/login', '/register', '/forget-pass'].includes(to.path)) {
        await store.dispatch('user/fetchCurrent')
    }

    if(to.matched.some(record => record.meta.requiresAuth)) {
        if (!store.getters['auth/isLoggedIn']) {
            next('/login')
            return
        }
    }

    if (!to.meta.middleware || to.meta.middleware.length === 0) {
        return next()
    }
    const middleware = to.meta.middleware

    const context = {
        to,
        from,
        next,
        store
    }

    return middleware[0]({
        ...context,
        next: middlewarePipeline(context, middleware, 1)
    })
})

export default router;